// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","571":"b637e9a5","895":"component---src-templates-page-tsx"}[chunkId] + "-" + {"532":"65eadf882f42bacc9e1d","571":"69b21da1efd62854fd5e","895":"7ffd05836ee269c120aa"}[chunkId] + ".js";
};